<script setup>
import { addThousandsSeparator } from '~/utils/utils.js';
import Card from '~/components/Card.vue';
import LoadingSkeleton from '~/components/LoadingSkeleton.vue';

// Props
const props = defineProps({
    addressRanges: { type: Array, default: [] },
    loading: { type: Boolean, default: false }
});
</script>

<template>
    <Card>
        <!-- Section Header -->
        <div class="flex items-center mb-6">
            <CardLabel text="Kaspa Addresses by Balance" />
            <InfoTooltip text="The number of addresses holding a certain amount of KAS" />
        </div>

        <!-- Stats Grid -->
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            <template v-if="props.loading">
                <div v-for="i in 10" :key="i">
                    <LoadingSkeleton height="92px" width="100%" />
                </div>
            </template>
            <template v-else>
                <div v-for="(stat, index) in props.addressRanges" :key="index" class="slide-in-up">
                    <div class="relative overflow-hidden rounded-xl p-4 bg-gradient-to-br from-[#70C7BA]/10 to-[#4A8F85]/10 dark:from-[#70C7BA]/20 dark:to-[#4A8F85]/20">
                        <div class="text-sm font-semibold text-gray-600 dark:text-gray-400 truncate">
                            {{ stat.range }} KAS
                        </div>
                        <div class="text-xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#70C7BA] to-[#4A8D83] dark:text-white mt-2">
                            {{ addThousandsSeparator(stat.count, 0) }}
                        </div>
                        <div class="absolute top-0 right-0 w-16 h-16 opacity-10 bg-gradient-to-br from-[#70C7BA] to-[#4A8F85] rounded-full -mr-8 -mt-8"></div>
                    </div>
                </div>
            </template>
        </div>
    </Card>
</template>

<style scoped>
.grid {
    view-transition-name: stats-grid;
}
</style>